import React from 'react';
import classNames from 'classnames';

import css from './IconArrow.module.css';

const DIRECTION_DOWN = 'down';
const DIRECTION_UP = 'up';

/**
 * Icon with arrow pointing up or down.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {('up' | 'down')} props.direction
 * @returns {JSX.Element} arrow icon
 */
const IconArrow = props => {
  const { className, rootClassName, direction } = props;
  const classes = classNames(rootClassName || css.root, className);

  const isUp = direction === DIRECTION_UP;

  return isUp ? (
    <svg
      className={classes}
      width="11"
      height="13"
      viewBox="-0.5 -0.5 12 14"
      xmlns="http://www.w3.org/2000/svg"
      role="none"
    >
      <path d="M5.18029 0.000651042C5.19202 0.000886234 5.20374 0.0011023 5.21544 0.00195312C5.24809 0.00431924 5.27998 0.00937754 5.31115 0.016276C5.31855 0.0179115 5.32593 0.0195942 5.33328 0.0214844C5.37813 0.0330403 5.42086 0.0495265 5.46154 0.0696615C5.52506 0.10105 5.58507 0.142411 5.63797 0.195312L10.138 4.69531C10.3983 4.95566 10.3983 5.37768 10.138 5.63802C9.87763 5.89836 9.45561 5.89835 9.19526 5.63802L5.83328 2.27604V11.6667C5.83328 12.0348 5.53478 12.3333 5.16662 12.3333C4.79843 12.3333 4.49995 12.0349 4.49995 11.6667V2.27604L1.13797 5.63802C0.877629 5.89836 0.455614 5.89835 0.195262 5.63802C-0.0650874 5.37767 -0.0650874 4.95566 0.195262 4.69531L4.69526 0.195312C4.73338 0.157203 4.77647 0.124376 4.82287 0.0963542C4.83616 0.0883226 4.84952 0.0805878 4.86323 0.0735677C4.90479 0.0522701 4.94869 0.0350431 4.99474 0.0227865C5.00579 0.0198437 5.01679 0.0166885 5.02794 0.0143229C5.03526 0.0127768 5.04268 0.0117209 5.05008 0.0104167C5.06176 0.00834888 5.07348 0.00665068 5.08524 0.00520833C5.09708 0.00376699 5.10902 0.00276477 5.12104 0.00195312C5.13167 0.00122497 5.1423 0.000872046 5.15294 0.000651042C5.15748 0.000560119 5.16206 0 5.16662 0C5.17119 3.37044e-07 5.17574 0.00055911 5.18029 0.000651042Z" />
    </svg>
  ) : (
    <svg
      className={classes}
      width="11"
      height="13"
      viewBox="-0.5 -0.5 12 14"
      xmlns="http://www.w3.org/2000/svg"
      role="none"
    >
      <path d="M5.16662 0C5.53478 2.71431e-05 5.83328 0.298494 5.83328 0.666667V10.0573L9.19526 6.69531C9.45561 6.43499 9.87763 6.43497 10.138 6.69531C10.3983 6.95566 10.3983 7.37768 10.138 7.63802L5.63797 12.138C5.60695 12.169 5.57238 12.1963 5.53576 12.2207C5.50967 12.2381 5.4828 12.2536 5.45503 12.2669C5.4247 12.2815 5.39329 12.2941 5.36063 12.304C5.34947 12.3074 5.33806 12.3097 5.32677 12.3125C5.31637 12.3151 5.30611 12.3182 5.29552 12.3203C5.29079 12.3212 5.28595 12.3214 5.2812 12.3223C5.24391 12.3287 5.20576 12.3333 5.16662 12.3333C5.12886 12.3333 5.09199 12.3289 5.05594 12.3229C5.049 12.3218 5.04201 12.321 5.03511 12.3197C5.02744 12.3181 5.01989 12.3162 5.01232 12.3145C4.99861 12.3112 4.98483 12.3082 4.9713 12.304C4.93887 12.2941 4.90768 12.2815 4.87755 12.2669C4.85103 12.2542 4.82507 12.2398 4.80008 12.2233C4.76231 12.1984 4.72714 12.1699 4.69526 12.138L0.195262 7.63802C-0.0650874 7.37767 -0.0650874 6.95566 0.195262 6.69531C0.455614 6.43499 0.877629 6.43497 1.13797 6.69531L4.49995 10.0573V0.666667C4.49995 0.298477 4.79843 0 5.16662 0Z" />
    </svg>
  );
};

export default IconArrow;
